import { Skeletons } from '../Skeletons';

export const SkeletonForIosSetupModal = () => {
  return (
    <div className="p-[20px] gap-y-[10px] h-full 768:min-w-[550px] max-w-[550px] min-w-full text-ism_text">
      <Skeletons count={1} className="min-w-[250px] my-[10px] max-w-[250px] h-[20px]" />
      <Skeletons count={1} className="min-w-[300px] max-w-[300px] h-[20px]" />
      <Skeletons count={1} className="min-w-[150px] my-[10px] max-w-[150px] h-[200px]" />
      <Skeletons count={1} className="min-w-[300px] max-w-[300px] h-[20px]" />
      <Skeletons count={1} className="min-w-[300px] my-[10px] max-w-[300px] h-[20px]" />
      <Skeletons count={1} className="min-w-[150px] my-[10px] max-w-[150px] h-[200px]" />
      <Skeletons count={1} className="min-w-[200px] my-[10px] max-w-[200px] h-[20px]" />
      <Skeletons count={1} className="min-w-[250px] my-[10px] max-w-[250px] h-[20px]" />
      <Skeletons count={1} className="min-w-[320px] max-w-[320px] h-[20px]" />
      <Skeletons count={1} className="min-w-[300px] my-[10px] max-w-[300px] h-[20px]" />
    </div>
  );
};
